export const CheckFillIcon = props => (
  <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='0.5' y='0.5' width='25' height='25' rx='3.5' stroke='#4361EE' />
    <path
      d='M11.6665 15.1146L17.7947 8.98633L18.7375 9.92914L11.6665 17.0002L7.42383 12.7576L8.36664 11.8148L11.6665 15.1146Z'
      fill='#4361EE'
    />
  </svg>
);
